import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { TRANSITION } from 'shared/components/motion/tokens';

interface RevealProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  /** Distância do deslocamento vertical de entrada, em px. */
  y?: number;
}

export function Reveal({ children, className, delay = 0, y = 16 }: RevealProps) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '0px 0px -40px 0px' }}
      transition={{ ...TRANSITION, delay }}
    >
      {children}
    </motion.div>
  );
}
